import { Skeleton } from "@mui/material";
import useTitanApp from "@/hooks/useTitanApp";

export default function PrescriptionApprovalSkeleton() {
  const { appState } = useTitanApp();
  const { darkMode } = appState;
  const isDarkMode = darkMode;

  const skeletonSx = { bgcolor: isDarkMode ? "grey.800" : "" };
  const rows = Array(6).fill(null);

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <Skeleton
          animation="wave"
          variant="rectangular"
          width="15%"
          height={20}
          className="rounded"
          sx={skeletonSx}
        />
      </div>

      {/* Search + Filter Row */}
      <div className="flex items-center justify-between gap-4">
        <Skeleton
          animation="wave"
          variant="rectangular"
          width="85%"
          height={30}
          className="rounded"
          sx={skeletonSx}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          width="12%"
          height={30}
          className="rounded"
          sx={skeletonSx}
        />
      </div>

      {/* Table Skeleton */}
      <div className="border rounded-lg overflow-hidden">
        {/* Table Header (lighter background, no animation for stability) */}
        <div
          className={`grid grid-cols-6 p-3 font-medium text-sm ${
            isDarkMode ? "bg-gray-900" : "bg-gray-100"
          }`}
        >
          {[
            "Patient",
            "Medication",
            "Prescribed By",
            "Service",
            "Date",
            "Actions",
          ].map((header, idx) => (
            <Skeleton
              key={idx}
              animation={false}
              variant="text"
              width="70%"
              height={18}
              sx={{ ...skeletonSx, bgcolor: "grey.300" }}
            />
          ))}
        </div>

        {/* Table Rows */}
        {rows.map((_, index) => (
          <div
            key={index}
            className={`grid grid-cols-6 items-center px-3 py-4 border-t ${
              isDarkMode ? "border-gray-700" : "border-gray-200"
            }`}
          >
            {/* Patient */}
            <Skeleton
              animation="wave"
              variant="text"
              width="80%"
              height={22}
              sx={skeletonSx}
            />
            {/* Medication */}
            <Skeleton
              animation="wave"
              variant="text"
              width="50%"
              height={22}
              sx={skeletonSx}
            />
            {/* Prescribed By */}
            <Skeleton
              animation="wave"
              variant="text"
              width="60%"
              height={22}
              sx={skeletonSx}
            />
            {/* Service (badge style) */}
            <Skeleton
              animation="wave"
              variant="rectangular"
              width={100}
              height={26}
              className="rounded-full"
              sx={skeletonSx}
            />
            {/* Date */}
            <Skeleton
              animation="wave"
              variant="text"
              width="70%"
              height={22}
              sx={skeletonSx}
            />
            {/* Actions */}
            <div className="flex gap-2 justify-end">
              <Skeleton
                animation="wave"
                variant="circular"
                width={28}
                height={28}
                sx={skeletonSx}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={70}
                height={28}
                sx={skeletonSx}
              />
              <Skeleton
                animation="wave"
                variant="circular"
                width={28}
                height={28}
                sx={skeletonSx}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
